import React, { useState, useEffect } from "react";
import { Modal, Box, TextField, Button, Typography, MenuItem, FormControlLabel, Switch } from "@mui/material";
import { ButtonOutline } from "../styledConstants";
import DistributorTable from "./DistributorTable";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import ApiRequest from "../../utils/ApiRequest";
import config from "../../utils/config";
import DistributorExportButtons from "./DistributorExportButtons";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Button as ButtonV2 } from "../../v2/design-system";
import { theme } from "../../v2/design-system/theme";
import styled from "styled-components";

// Validation schema using Yup
const distributorSchema = Yup.object().shape({
  programManagerCode: Yup.string().required('Program Manager is required'),
  name: Yup.string().required("*Name is required"),
  orgName: Yup.string().required("*Organization Name is required"),
  mobileNumber: Yup.string()
    .required("*Mobile number is required")
    .matches(/^\d{10}$/, "Mobile must be a 10-digit number"),
  email: Yup.string().email("Invalid email format").required("*Email is required"),
  orgCode: Yup.string().required("*Organization Code is required"),
  address: Yup.string().required("*Address is required"),
});

const TopBar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.lg};
`;

const ActionsRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.sm};
  flex-wrap: wrap;
`;

function Distributor({ variant = "v1" }) {
  const isV2 = variant === "v2";
  const [open, setOpen] = useState(false);
  const [consentCheckboxDisabled, setConsentCheckboxDisabled] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [programManagers, setProgramManagers] = useState([]);

// useEffect(() => {
//   const fetchProgramManagers = async () => {
//     try {
//       const res = await axios.get(
//         'https://uat-apps.mufinpay.com/api-service/user/api/programManagerList',
//         {
//           headers: {
//             'apikey': 'e9480c57-0bed-45f7-b7d2-79a06w20p',
//           },
//         }
//       );

//       if (res.data && Array.isArray(res.data.data)) {
//         setProgramManagers(res.data.data);
//       } else {
//         console.error('Unexpected response:', res.data);
//       }
//     } catch (err) {
//       console.error('Failed to fetch program managers', err);
//     }
//   };

//   fetchProgramManagers();
// }, []);


useEffect(() => {
  const successHandler = (res) => {
    if (res.data && Array.isArray(res.data.data)) {
      setProgramManagers(res.data.data);
    } else {
      console.error("Unexpected response:", res);
    }
  };

  const errorHandler = (err) => {
    console.error("Failed to fetch program managers", err);
  };

  const api = new ApiRequest("", successHandler, errorHandler);
  return api.get(`${config.apis.admin.PROG_LIST}`);
}, []);




  const initialValues = {
    // programManager: '', 
    programManagerCode:'',
    name: "",
    orgName: "",
    mobileNumber: "",
    email: "",
    orgCode: "",
    address: "",
    userConsentRequired: true,
    userVkycRequired: true,
    cashbackRequired: false,
    settlementEnabled: false 
  };
   const handleSubmit = (values, { resetForm }) => {
     const successHandler = (res) => {
    if (res?.data?.code === "0000") {
      if (isV2) {
        toast.success("Society partner registered successfully.");
      } else {
        alert("Society Partner registered successfully!");
      }
      resetForm();
      handleClose();
    } else {
      const msg = res?.data?.message || "Something went wrong";
      alert(msg);
    }
  };

  const errorHandler = (err) => {
    console.error("API Error:", err);
    const message =
      (err && err.message) ||
      (err && err.data && err.data.message) ||
      "Failed to register Society Partner. Please try again.";
    if (isV2) toast.error(message);
    else alert(message);
  };

  const api = new ApiRequest("", successHandler, errorHandler);

  return api.post(`${config.apis.admin.CREATE_SOCIETY}`,values);
};

  // const handleSubmit = async (values, { resetForm }) => {
  //   try {
  //     console.log("Form values being submitted:", values);
  //     const response = await  fetch("https://uat-apps.mufinpay.com/api-service/user/api/create", {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         "apikey": "e9480c57-0bed-45f7-b7d2-79a06w20p",
  //       },
  //       body: JSON.stringify(values),
  //     });
  
  //     if (response.ok) {
  //       const result = await response.json();
  //       console.log("Distributor created:", result);
  //       alert("Society Partner registered successfully!");
  //       resetForm();
  //       handleClose();
  //     } else {
  //       const errorData = await response.json();
  //       console.error("API Error:", errorData);
  //       alert(`Failed to register Society Partner: ${errorData.message || 'Please try again.'}`);
  //     }
  //   } catch (error) {
  //     console.error("Network Error:", error);
  //     alert("Network error. Please check your connection.");
  //   }
  // };
  
  return (
    <div>
      <>
        <div className="flex justify-end mb20">
          <DistributorExportButtons />
        </div>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} width="100%">
          <Typography variant="h5" fontWeight="bold" color="white">
            Society Partner List
          </Typography>
          <ButtonOutline rg className="flex flex-center" primary onClick={handleOpen}>
            Create Society Partner
          </ButtonOutline>
        </Box>
      </>


    <Modal open={open} onClose={handleClose}>
     <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 500,
        maxHeight: "90vh",
        overflow: "hidden",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
      }}
>

          <Typography variant="h6" component="h2" textAlign="center" mb={2}>
            Society Partner Registration
          </Typography>

          <Formik
            initialValues={initialValues}
            validationSchema={distributorSchema}
            onSubmit={handleSubmit}
          >
            {({ values, errors, touched, handleChange, handleBlur, setFieldValue }) => (
           
           <Form
            style={{
              display: "flex",
              flexDirection: "column",
              flex: 1,
              minHeight: 0,
            }}
          >
             <Box
            sx={{
            flex: 1,
            minHeight: 0,
            maxHeight: "min(58vh, calc(90vh - 220px))",
            overflowY: "auto",
            overflowX: "hidden",
            pr: 0.5,
            scrollbarGutter: "stable",
            "&::-webkit-scrollbar": {
              width: 10,
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "rgba(0,0,0,0.06)",
              borderRadius: 5,
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "rgba(0,0,0,0.35)",
              borderRadius: 5,
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.5)",
              },
            },
            scrollbarWidth: "auto",
          }}
      >            
                <Typography variant="subtitle1" fontWeight="bold" mt={1}>
                  Program Manager
                </Typography>
                
                <TextField
                  select
                  fullWidth
                  label="Select Program Manager"
                  name="programManagerCode"
                  variant="outlined"
                  margin="normal"
                  value={values.programManagerCode}
                  onChange={(e) => {
  const selectedCode = e.target.value;
  const selectedPM = programManagers.find(
    pm => pm.programManagerCode === selectedCode
  );

  setFieldValue("programManagerCode", selectedCode);

  if (selectedPM) {
    const consentRequired = selectedPM.userConsent === true;

    setFieldValue("userConsentRequired", consentRequired);
    setFieldValue("userVkycRequired", consentRequired);

    // 🔥 NEW → cashback required handling from API field
    setFieldValue(
      "cashbackRequired",
      selectedPM.cashbackRequired === true
    );

    setConsentCheckboxDisabled(true);
  } else {
    setFieldValue("userConsentRequired", true);
    setFieldValue("userVkycRequired", true);
    setFieldValue("cashbackRequired", true);
    setConsentCheckboxDisabled(false);
  }
}}

                  onBlur={handleBlur}
                  error={touched.programManagerCode && Boolean(errors.programManagerCode)}
                  helperText={touched.programManagerCode && errors.programManagerCode}
                >
                  {programManagers.map((pm) => (
                    <MenuItem key={pm.programManagerCode} value={pm.programManagerCode}>
                    {pm.programManagerName}
                     </MenuItem>
                      ))}

                </TextField>
                       <FormControlLabel
                   control={
                     <Switch
                       checked={values.cashbackRequired}
                       onChange={(e) => setFieldValue("cashbackRequired", e.target.checked)}
                       sx={{
                         '& .MuiSwitch-switchBase.Mui-checked': {
                           color: '#16a34a', // green knob
                         },
                         '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                           backgroundColor: '#16a34a', // green track when ON
                         },
                         '& .MuiSwitch-track': {
                           backgroundColor: '#9ca3af', // track color when OFF (gray)
                         },
                       }}
                     />
                   }
                   label="Cashback"
                 />
                  <FormControlLabel
                   control={
                  <Switch
                    checked={values.settlementEnabled}
                    onChange={(e) =>
                      setFieldValue("settlementEnabled", e.target.checked)
                    }
                    sx={{
                      '& .MuiSwitch-switchBase.Mui-checked': {
                       color: '#16a34a', // green knob
                      },
                      '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                        backgroundColor: '#16a34a',
                      },
                      '& .MuiSwitch-track': {
                        backgroundColor: '#9ca3af',
                      },
                    }}
                  />
                }
                label="Enable Settlement"
              />
                <Typography variant="subtitle1" fontWeight="bold" mt={1}>
                    Personal Details
                  </Typography>
                <TextField
                  fullWidth
                  label="Full Name"
                  name="name"
                  variant="outlined"
                  margin="normal"
                  value={values.name}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.name && Boolean(errors.name)}
                  helperText={touched.name && errors.name}
                  />

                {/* <TextField
                  fullWidth
                  label="Organization Name"
                  name="orgName"
                  variant="outlined"
                  margin="normal"
                  value={values.orgName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.orgName && Boolean(errors.orgName)}
                  helperText={touched.orgName && errors.orgName}
                  /> */}

                <TextField
                  fullWidth
                  label="Mobile Number"
                  name="mobileNumber"
                  variant="outlined"
                  margin="normal"
                  value={values.mobileNumber}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.mobileNumber && Boolean(errors.mobileNumber)}
                  helperText={touched.mobileNumber && errors.mobileNumber}
                  />

                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  type="email"
                  variant="outlined"
                  margin="normal"
                  value={values.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.email && Boolean(errors.email)}
                  helperText={touched.email && errors.email}
                  />
                    <Typography variant="subtitle1" fontWeight="bold" mt={3}>
                    Organization Details
                  </Typography>
                 <TextField
                  fullWidth
                  label="Organization Name"
                  name="orgName"
                  variant="outlined"
                  margin="normal"
                  value={values.orgName}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.orgName && Boolean(errors.orgName)}
                  helperText={touched.orgName && errors.orgName}
                  />
                <TextField
                  fullWidth
                  label="Organization Code"
                  name="orgCode"
                  variant="outlined"
                  margin="normal"
                  value={values.orgCode}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  error={touched.orgCode && Boolean(errors.orgCode)}
                  helperText={touched.orgCode && errors.orgCode}
                  />
               <TextField
               fullWidth
               label="Address"
               name="address"
               variant="outlined"
               margin="normal"
               multiline
               rows={3}
               value={values.address}
               onChange={handleChange}
               onBlur={handleBlur}
               error={touched.address && Boolean(errors.address)}
               helperText={touched.address && errors.address}
               />

                <div style={{ display: "flex", justifyContent: "space-between", marginTop: "1rem" }}>
                 <label>
                <input
                   type="checkbox"
                   name="userConsentRequired"
                   checked={values.userConsentRequired}
                   disabled={consentCheckboxDisabled}
                   onChange={(e) => setFieldValue("userConsentRequired", e.target.checked)}
                 />
                 &nbsp; User Consent Required
               </label>
               
               <label>
                 <input
                   type="checkbox"
                   name="userVkycRequired"
                   checked={values.userVkycRequired}
                   disabled={consentCheckboxDisabled}
                   onChange={(e) => setFieldValue("userVkycRequired", e.target.checked)}
                 />
                 &nbsp; User VKYC Required
               </label>

                </div>
                      </Box>

                <Box
                  mt={3}
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  gap={2}
                  flexWrap="wrap"
                >
                  <>
                    <Button variant="contained" color="error" onClick={handleClose}>
                      Cancel
                    </Button>
                    <Button type="submit" variant="contained" color="success">
                      Register
                    </Button>
                  </>
                </Box>
              </Form>
            )}
          </Formik>
        </Box>
      </Modal>

      {!isV2 ? <br /> : null}
      <DistributorTable variant={variant} />

    </div>
  );
}

export default Distributor;  